
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as ClossIcon } from "../fontello/icons/svg/ic_closs.svg"


const Closs = ({ ...props }) => (
  <SvgIcon
    component={ClossIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Closs
